import React from 'react';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import { TeamAttributes } from '@app/models/dtos/strapi';
import environments from '@app/configs/environments';

function TeamCard({ teamAttributes }: { teamAttributes: TeamAttributes }) {
    return (
        <div className="!h-[404px] max-h-[404px] w-full">
            <div className="h-[347px] max-h-[347px] w-full">{teamAttributes.image && <ImageRenderer media={environments.STRAPI_HOST_URL + teamAttributes.image.url} />}</div>
            <p className="P1 mt-3 text-black-1">{teamAttributes.name}</p>
            <p className="P2 text-black-2">{teamAttributes.position}</p>
        </div>
    );
}

export default TeamCard;
